import React, { Component } from "react";
import { Button, Col, Container, Form, Input, Row } from "reactstrap";
import { connect } from "react-redux";
import * as actions from "../../actions";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getAccessToken, hasAccessToken } from "../../constants/auth";
import { Spinner } from "react-activity";
import "react-activity/dist/react-activity.css";
import "./Login.css";

class Login extends Component {
  componentDidMount() {
    if (hasAccessToken()) {
      this.props.updateLoginProps([{ prop: "token", value: getAccessToken() }]);
      this.props.history.push("/home");
    }
  }

  handleSubmit = event => {
    event.preventDefault();
    const { username, password } = this.props.loginReducer;
    this.props.login(username, password, this.props.history);
  };

  render() {
    const { username, password, isLoginLoading } = this.props.loginReducer;
    const currentYear = new Date().getFullYear();

    return (
      <div className="login-page">
        <ToastContainer />
        <div className="login-page__ambient login-page__ambient--one" />
        <div className="login-page__ambient login-page__ambient--two" />

        <Container className="login-page__container">
          <Row className="justify-content-center">
            <Col xl="10" lg="11">
              <div className="login-shell">
                <div className="login-shell__brand">
                  <div className="login-brand-card">
                    <div className="login-brand-card__eyebrow">Faiz Backoffice</div>
                    <img
                      className="login-brand-card__logo"
                      alt="Faiz Logo"
                      src={"assets/img/faiz-logo.png"}
                    />
                    <h1 className="login-brand-card__title">Smart Schedule Builder.</h1>
                    <p className="login-brand-card__copy">
                      Monitor reservations, shape schedules, and manage the full operations flow
                      from a single focused workspace.
                    </p>

                    <div className="login-brand-card__highlights">
                      <div className="login-highlight">
                        <span className="login-highlight__value">Live</span>
                        <span className="login-highlight__label">Reservation scheduling</span>
                      </div>
                      <div className="login-highlight">
                        <span className="login-highlight__value">Smart</span>
                        <span className="login-highlight__label">Efficiency planning</span>
                      </div>
                      <div className="login-highlight">
                        <span className="login-highlight__value">Unified</span>
                        <span className="login-highlight__label">Hotels, venues, and users</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="login-shell__form">
                  <div className="login-panel">
                    <div className="login-panel__header">
                      <div className="login-panel__kicker">Welcome back</div>
                      <h2 className="login-panel__title">Sign in to continue</h2>
                      <p className="login-panel__subtitle">
                        Use your backoffice email and password to access the dashboard.
                      </p>
                    </div>

                    <Form onSubmit={this.handleSubmit}>
                      <div className="login-field">
                        <label className="login-field__label" htmlFor="login-email">
                          Email
                        </label>
                        <div className="login-field__control">
                          <i className="fa fa-envelope-o login-field__icon" />
                          <Input
                            id="login-email"
                            className="login-field__input"
                            value={username}
                            onChange={e => {
                              this.props.updateLoginProps([{ prop: "username", value: e.target.value }]);
                            }}
                            type="email"
                            placeholder="name@company.com"
                            autoComplete="username"
                          />
                        </div>
                      </div>

                      <div className="login-field">
                        <label className="login-field__label" htmlFor="login-password">
                          Password
                        </label>
                        <div className="login-field__control">
                          <i className="fa fa-lock login-field__icon" />
                          <Input
                            id="login-password"
                            className="login-field__input"
                            value={password}
                            onChange={e => {
                              this.props.updateLoginProps([{ prop: "password", value: e.target.value }]);
                            }}
                            type="password"
                            placeholder="Enter your password"
                            autoComplete="current-password"
                          />
                        </div>
                      </div>

                      <div className="login-panel__actions">
                        <Button
                          type="submit"
                          color="faiz1"
                          className="login-submit"
                          disabled={isLoginLoading}
                        >
                          <Spinner size={10} animating={isLoginLoading} color={"white"} />
                          <span>Sign in</span>
                        </Button>

                        <button type="button" className="login-panel__link">
                          Need help accessing your account?
                        </button>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>

              <div className="login-page__footer">
                <span>
                  &copy; {currentYear}{" "}
                  <a
                    className="login-page__footer-link"
                    href="https://faizehaakimi.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    FAIZ-E-HAAKIMI
                  </a>
                  .
                </span>
                <span>
                  Powered by{" "}
                  <a
                    className="login-page__footer-link"
                    href="https://pssolutions.me"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    PS Solutions
                  </a>
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({ loginReducer }) => ({
  loginReducer
});

export default connect(
  mapStateToProps,
  actions
)(Login);
